// extracted by mini-css-extract-plugin
export default {"brandDirectIcon":"IconBrandDirectExplainer_brandDirectIcon__rln20","customBrandDirectIcon":"IconBrandDirectExplainer_customBrandDirectIcon__1Z5R-"};